import { memo } from 'react';

import { Flex, Tooltip, Typography } from 'antd';

const { Title, Text } = Typography;

function SectionHeader({ className, title, subtitle, children }) {
  return (
    <Flex className={className} vertical={true} flex="1 1 auto">
      {title && (
        <Title ellipsis={true} level={4} style={!subtitle && !children && { marginBottom: '22px' }}>
          {title}
        </Title>
      )}
      {subtitle && (
        <Text type="secondary" ellipsis={true}>
          {subtitle}
        </Text>
      )}
      {children}
    </Flex>
  );
}

export default memo(SectionHeader);
